import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  Label,
  Input,
  Button,
  FormFeedback,
} from "reactstrap";
import Breadcrumbs from "components/Common/BreadcrumbTitle";
import { getAllEntity, getEntity, getOneEntity, getTaskById, updateTask } from "http/fundLync/entityAndAddress.helper";
import { getDropDownList } from "http/fundLync/dropdown.helper";
import ToastDialog from "components/Common/ToastDialog";
import * as Yup from "yup";
import { Formik } from "formik";
import { getEntityWiseDeal } from "http/fundLync/deal.helper";

const UpdateEntityTask = ({editTaskId,onUpdate,onCancel}) => {
    
  
  const [toastInfo, setToastInfo] = useState({ showToast: false, message: "", role: "" });
  const currentDate = new Date().toISOString().split("T")[0];
  const [typeList, setTypeList] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [priorityList, setPriorityList] = useState([]);
  const [reminderList, setReminderList] = useState([]);
  const [entityList, setEntityList] = useState([]);
  const [dealList, setDealList] = useState([]);
  const [selectedEntity, setSelectedEntity] = useState('');
  const [initialValues, setInitialValues] = useState({
    id: "",
    entityId: "",
    dealId:"",  
    taskName: "",
    taskType: "",
    taskDescription: "",
    taskStatus: "",
    taskPriority: "",
    dueDate: "",
    dueTime: "",
    taskReminder: "",
  });


  const validationSchema = Yup.object({
    taskName: Yup.string().required("Task Name is required"),
  });

  useEffect(() => {
    try {
      getTaskById({ Id : editTaskId})
        .then((response) => {
          const formattedDate = response.dueDate.split(" ")[0];
          setInitialValues({
            id: response.id,
            entityId: response.entityId,
            dealId: response.dealId, 
            taskName: response.taskName,
            taskType: response.taskType,
            taskDescription: response.taskDescription,
            taskStatus: response.taskStatus,
            taskPriority: response.taskPriority,
            dueDate: formattedDate,
            dueTime: response.dueTime,
            taskReminder: response.taskReminder,
          });
        })
        .catch((error) => {
          console.log(error);
        });
      
    } 
    catch (e) {
      console.error("Invalid base64 string", e);
    }



    getDropDownList({ dropdownName: "Task_Type" })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find((dv) => dv.dropdownName === "Task_Type")
            ?.dropdownValues || [];
        setTypeList(dropdownValues);
      })
      .catch((error) => {
        console.log("Error fetching data", error);
      });

    getDropDownList({ dropdownName: "Task_Status" })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find((dv) => dv.dropdownName === "Task_Status")
            ?.dropdownValues || [];
        setStatusList(dropdownValues);
      })
      .catch((error) => {
        console.log("Error fetching data", error);
      });

    getDropDownList({ dropdownName: "Task_Priority" })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find((dv) => dv.dropdownName === "Task_Priority")
            ?.dropdownValues || [];
        setPriorityList(dropdownValues);
      })
      .catch((error) => {
        console.log("Error fetching data", error);
      });

    getDropDownList({ dropdownName: "Reminder" })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find((dv) => dv.dropdownName === "Reminder")
            ?.dropdownValues || [];
        setReminderList(dropdownValues);
      })
      .catch((error) => {
        console.log("Error fetching data", error);
      });

      let totalValues;
      getEntity()
       .then((response) =>{
        totalValues = response.data.totalItems; 
          getEntity({limit:totalValues})
          .then((response) => {
              setEntityList(response?.data?.data);
          })
          .catch((error) => {
            console.log(error)
          })
       }) 
      .catch((error) => {
        console.log(error)
      })

  }, [editTaskId]);

  useEffect(() => {
    if (initialValues.entityId) {
      getOneEntity({ entityId: initialValues.entityId })
        .then((response) => {
          if (response.code === 200 && response.status) {
            setSelectedEntity(response.data[0]);
          }
        })
        .catch((error) => {
          console.error(error);
        });

      getEntityWiseDeal({ entityId: initialValues.entityId })
        .then((response) => {
          if (response?.data?.rows.length > 0) {
            setDealList(response.data.rows);
          } else {
            setDealList([{ id: null, dealName: "No Deals Found" }]);
          }
        })
        .catch((error) => {
          console.error(error);
          setDealList([]);
        });
    }
  }, [initialValues.entityId]);

  const handleEntityChange = (event) => {
    const newEntityId = event.target.value;
    setInitialValues({ ...initialValues, entityId: newEntityId });

    getEntityWiseDeal({ entityId: newEntityId })
      .then((response) => {
        if (response?.data?.rows.length > 0) {
          setDealList(response.data.rows);
        } else {
          setDealList([{ id: null, dealName: "No Deals Found" }]);
        }
      })
      .catch((error) => {
        console.error(error);
        setDealList([]);
      });
  };

  const handleSave = (values) => {
    const updatedTask = {
      id: editTaskId,
      entityId: values.entityId,
      dealId: values.dealId,
      taskName: values.taskName,
      taskType: values.taskType,
      taskDescription: values.taskDescription,
      taskStatus: values.taskStatus,
      taskPriority: values.taskPriority,
      dueDate: values.dueDate,
      dueTime: values.dueTime,
      taskReminder: values.taskReminder,
    };

    updateTask(updatedTask)
      .then((response) => {
        setToastInfo({
          message: "Details Updated Successfully",
          showToast: true,
          role: "success",
        });
        setTimeout(() => {
          onUpdate();
          handleCancel();
        }, 2000);

      })
      .catch((error) => {
        console.log(error);
      });
      
  };

  const handleCancel = () => {
    onCancel();
    //navigate(-1);
  };

  return (
    <React.Fragment>
      <div className="page-content" style={{marginTop:"-80px"}}>
        <Container fluid>
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSave}
                    enableReinitialize
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleSubmit,
                    }) => (
                      <Form onSubmit={handleSubmit}>
                        <Row className="mb-3">
                          <Col sm="6">
                            <Label for="title">Entity Name</Label>
                            <Input
                              type="select"
                              name="entityId"
                              value={values.entityId}
                              onChange={(e) => {
                                handleChange(e);
                                handleEntityChange(e);
                              }}
                            >
                              {entityList.map((item) => (
                                <option key={item.id} value={item.id}>
                                  {item.entityName}
                                </option>
                              ))}
                            </Input>
                          </Col>
                          <Col sm="6">
                            <Label for="title">Deal Name</Label>
                            <Input
                              type="select"
                              name="dealId"
                              value={values.dealId}
                              onChange={handleChange}
                              placeholder="select deal"
                            >
                              <option value="" disabled>Select deal</option>
                              {dealList.map((item) => (
                                <option key={item.id} value={item.id}>
                                  {item.dealName}
                                </option>
                              ))}
                            </Input>
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col sm="6">
                            <Label for="title">Task Name</Label>
                            <Input
                              type="text"
                              name="taskName"
                              value={values.taskName}
                              onChange={handleChange}
                              invalid={touched.taskName && !!errors.taskName}
                            />
                            {touched.taskName && errors.taskName && (
                              <FormFeedback>{errors.taskName}</FormFeedback>
                            )}
                          </Col>
                          <Col sm="6">
                            <Label for="date">Task Type</Label>
                            <Input
                              type="select"
                              name="taskType"
                              value={values.taskType}
                              onChange={handleChange}
                            >
                              <option value="" disabled>Select type</option>
                              {typeList.map((type) => (
                                <option key={type.id} value={type.dropdownValue}>
                                  {type.displayName}
                                </option>
                              ))}
                            </Input>
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col sm="6">
                            <Label for="description">Task Reminder</Label>
                            <Input
                              type="select"
                              name="taskReminder"
                              value={values.taskReminder}
                              onChange={handleChange}
                            >
                              <option value="" disabled>Select Reminder Time</option>
                              {reminderList.map((reminder) => (
                                <option key={reminder.id} value={reminder.dropdownValue}>
                                  {reminder.displayName}
                                </option>
                              ))}
                            </Input>
                          </Col>

                          <Col sm="6">
                            <Label for="date">Task Status</Label>
                            <Input
                              type="select"
                              name="taskStatus"
                              value={values.taskStatus}
                              onChange={handleChange}
                            >
                              {statusList.map((status) => (
                                <option key={status.id} value={status.dropdownValue}>
                                  {status.displayName}
                                </option>
                              ))}
                            </Input>
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col sm="6">
                            <Label for="description">Task Priority</Label>
                            <Input
                              type="select"
                              name="taskPriority"
                              value={values.taskPriority}
                              onChange={handleChange}
                            >
                              <option value="" disabled>Select Priority</option>
                              {priorityList.map((priority) => (
                                <option key={priority.id} value={priority.dropdownValue}>
                                  {priority.displayName}
                                </option>
                              ))}
                            </Input>
                          </Col>
                          <Col sm="6">
                            <Label for="description">Due Date</Label>
                            <Input
                              type="date"
                              name="dueDate"
                              value={values.dueDate}
                              onChange={handleChange}
                              min={currentDate}
                            />
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col sm="6">
                            <Label for="description">Due Time</Label>
                            <Input
                              type="time"
                              name="dueTime"
                              value={values.dueTime}
                              onChange={handleChange}
                            />
                          </Col>

                          <Col sm="6">
                            <Label for="date">Task Description</Label>
                            <Input
                              type="textarea"
                              name="taskDescription"
                              value={values.taskDescription}
                              onChange={handleChange}
                            />
                          </Col>
                        </Row>

                        <div className="d-flex justify-content-end">
                          <Button type="submit" style={{ backgroundColor: '#21aa47', borderColor: '#21aa47' }} className="me-2">
                            Save
                          </Button>
                          <Button type="button" 
                            onClick={handleCancel}
                            outline
                            >
                            Cancel
                          </Button> 
                        </div>
                      </Form>
                    )}
                  </Formik>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
    </React.Fragment>
  );
};

export default UpdateEntityTask;

